import {getEnv} from '../../common/env/env';
import {ItemSeriesDto} from '../../common/shared/api/gateway/ItemSeriesDto.interface';
import {LandingPageVo} from '../../common/shared/api/karina/vo/page/LandingPageVo.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {
  ContentsType,
  Maybe,
  MetaInfoType,
  SeriesCardViewLandingList,
  User,
} from '../generated/types';
import {createCardViewItem} from './CardViewItem';
import {createSortOption} from './SortOption';

export function createSeriesCardViewLandingList(
  userInfo: Maybe<User>,
  landingPage: LandingPageVo<ItemSeriesDto>,
  id: string,
  page: number
): SeriesCardViewLandingList {
  return {
    id,
    isEnd: landingPage.is_end,
    totalCount: landingPage.total_count,
    type: ContentsType.Series,
    list: landingPage.list.map(item =>
      createCardViewItem(userInfo, {
        itemSeriesDto: item,
        metaInfoType: MetaInfoType.ViewCount,
      })
    ),
    themeKeywordOptList: landingPage.theme_keyword_opt_list?.map(sortOption =>
      createSortOption({filterOptionVo: sortOption})
    ),
    selectedThemeKeywordOpt: landingPage.selected_theme_keyword_opt
      ? createSortOption({
          filterOptionVo: landingPage.selected_theme_keyword_opt,
        })
      : undefined,
    title: landingPage.title,
    topImage: landingPage.top_image
      ? getKageUrl({
          kageId: landingPage.top_image,
          kageUrlPrefix: getEnv().kageUrlPrefix,
          resolution: 'o1',
        })
      : undefined,
    category: landingPage.list.length
      ? landingPage.list[0].category
      : undefined,
    page,
  };
}
